export default function (value) {
  const containsUppercase = /[A-Z]/.test(value);
  const containsLowercase = /[a-z]/.test(value);
  const containsNumber = /[0-9]/.test(value);
  const containsSpecial = /[~!@#$%^&*()-+=]/.test(value);
  return !value ? true : containsUppercase && containsLowercase && containsNumber && containsSpecial;
}
